// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  updateWorkflowLabel,
  deleteTestType,
  updateTestType,
  getGitRepoSettings,
  updateGitRepoSettings,
  updateWorkflowGroups,
  updateReleaseName,
  updateReleaseNotes,
  getEnvironmentById,
  updateEnvironment,
  unlockEnvironment,
  lockEnvironment,
  extendEnvironmentLock,
  syncWorkflowsByRepositoryId,
  getUserSettings,
  updateUserSettings,
  getNotificationPreferences,
  updateNotificationPreferences,
  getAllTestTypes,
  createTestType,
  createWorkflowGroup,
  deleteReleaseCandidateByName,
  getAllReleaseInfos,
  createReleaseCandidate,
  publishReleaseDraft,
  generateReleaseNotes,
  evaluate,
  getReleaseInfoByName,
  setPrPinnedByNumber,
  syncEnvironments,
  deployToEnvironment,
  setBranchPinnedByRepositoryIdAndNameAndUserId,
  healthCheck,
  getAllWorkflows,
  getWorkflowById,
  getWorkflowsByState,
  getWorkflowsByRepositoryId,
  getLatestWorkflowRunsByPullRequestIdAndHeadCommit,
  getLatestWorkflowRunsByBranchAndHeadCommit,
  getUserPermissions,
  getLatestTestResultsByPullRequestId,
  getLatestTestResultsByBranch,
  getGroupsWithWorkflows,
  getAllRepositories,
  getRepositoryById,
  getCommitsSinceLastReleaseCandidate,
  getAllPullRequests,
  getPullRequestById,
  getPullRequestByRepositoryIdAndNumber,
  getPullRequestByRepositoryId,
  getAllEnvironments,
  getEnvironmentReviewers,
  getEnvironmentsByUserLocking,
  getEnvironmentsByRepositoryId,
  getLockHistoryByEnvironmentId,
  getAllEnabledEnvironments,
  getAllDeployments,
  getDeploymentById,
  getDeploymentsByEnvironmentId,
  getLatestDeploymentByEnvironmentId,
  getActivityHistoryByEnvironmentId,
  getCommitByRepositoryIdAndName,
  getAllBranches,
  getBranchByRepositoryIdAndName,
  deleteWorkflowGroup,
} from '../sdk.gen';
import { type MutationOptions, queryOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/angular-query-experimental';
import type {
  UpdateWorkflowLabelData,
  UpdateWorkflowLabelError,
  DeleteTestTypeData,
  DeleteTestTypeError,
  DeleteTestTypeResponse,
  UpdateTestTypeData,
  UpdateTestTypeError,
  UpdateTestTypeResponse,
  GetGitRepoSettingsData,
  UpdateGitRepoSettingsData,
  UpdateGitRepoSettingsError,
  UpdateGitRepoSettingsResponse,
  UpdateWorkflowGroupsData,
  UpdateWorkflowGroupsError,
  UpdateReleaseNameData,
  UpdateReleaseNameError,
  UpdateReleaseNotesData,
  UpdateReleaseNotesError,
  GetEnvironmentByIdData,
  UpdateEnvironmentData,
  UpdateEnvironmentError,
  UpdateEnvironmentResponse,
  UnlockEnvironmentData,
  UnlockEnvironmentError,
  UnlockEnvironmentResponse,
  LockEnvironmentData,
  LockEnvironmentError,
  LockEnvironmentResponse,
  ExtendEnvironmentLockData,
  ExtendEnvironmentLockError,
  ExtendEnvironmentLockResponse,
  SyncWorkflowsByRepositoryIdData,
  SyncWorkflowsByRepositoryIdError,
  GetUserSettingsData,
  UpdateUserSettingsData,
  UpdateUserSettingsError,
  GetNotificationPreferencesData,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesError,
  GetAllTestTypesData,
  CreateTestTypeData,
  CreateTestTypeError,
  CreateTestTypeResponse,
  CreateWorkflowGroupData,
  CreateWorkflowGroupError,
  CreateWorkflowGroupResponse,
  DeleteReleaseCandidateByNameData,
  DeleteReleaseCandidateByNameError,
  DeleteReleaseCandidateByNameResponse,
  GetAllReleaseInfosData,
  CreateReleaseCandidateData,
  CreateReleaseCandidateError,
  CreateReleaseCandidateResponse,
  PublishReleaseDraftData,
  PublishReleaseDraftError,
  GenerateReleaseNotesData,
  GenerateReleaseNotesError,
  GenerateReleaseNotesResponse,
  EvaluateData,
  EvaluateError,
  GetReleaseInfoByNameData,
  GetReleaseInfoByNameError,
  GetReleaseInfoByNameResponse,
  SetPrPinnedByNumberData,
  SetPrPinnedByNumberError,
  SyncEnvironmentsData,
  SyncEnvironmentsError,
  SyncEnvironmentsResponse,
  DeployToEnvironmentData,
  DeployToEnvironmentError,
  DeployToEnvironmentResponse,
  SetBranchPinnedByRepositoryIdAndNameAndUserIdData,
  SetBranchPinnedByRepositoryIdAndNameAndUserIdError,
  HealthCheckData,
  GetAllWorkflowsData,
  GetWorkflowByIdData,
  GetWorkflowsByStateData,
  GetWorkflowsByRepositoryIdData,
  GetLatestWorkflowRunsByPullRequestIdAndHeadCommitData,
  GetLatestWorkflowRunsByBranchAndHeadCommitData,
  GetUserPermissionsData,
  GetLatestTestResultsByPullRequestIdData,
  GetLatestTestResultsByPullRequestIdError,
  GetLatestTestResultsByPullRequestIdResponse,
  GetLatestTestResultsByBranchData,
  GetLatestTestResultsByBranchError,
  GetLatestTestResultsByBranchResponse,
  GetGroupsWithWorkflowsData,
  GetAllRepositoriesData,
  GetRepositoryByIdData,
  GetCommitsSinceLastReleaseCandidateData,
  GetAllPullRequestsData,
  GetPullRequestByIdData,
  GetPullRequestByRepositoryIdAndNumberData,
  GetPullRequestByRepositoryIdData,
  GetAllEnvironmentsData,
  GetEnvironmentReviewersData,
  GetEnvironmentsByUserLockingData,
  GetEnvironmentsByRepositoryIdData,
  GetLockHistoryByEnvironmentIdData,
  GetAllEnabledEnvironmentsData,
  GetAllDeploymentsData,
  GetDeploymentByIdData,
  GetDeploymentsByEnvironmentIdData,
  GetLatestDeploymentByEnvironmentIdData,
  GetActivityHistoryByEnvironmentIdData,
  GetCommitByRepositoryIdAndNameData,
  GetAllBranchesData,
  GetBranchByRepositoryIdAndNameData,
  DeleteWorkflowGroupData,
  DeleteWorkflowGroupError,
} from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export const updateWorkflowLabelMutation = (options?: Partial<Options<UpdateWorkflowLabelData>>) => {
  const mutationOptions: MutationOptions<unknown, UpdateWorkflowLabelError, Options<UpdateWorkflowLabelData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateWorkflowLabel({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteTestTypeMutation = (options?: Partial<Options<DeleteTestTypeData>>) => {
  const mutationOptions: MutationOptions<DeleteTestTypeResponse, DeleteTestTypeError, Options<DeleteTestTypeData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteTestType({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateTestTypeMutation = (options?: Partial<Options<UpdateTestTypeData>>) => {
  const mutationOptions: MutationOptions<UpdateTestTypeResponse, UpdateTestTypeError, Options<UpdateTestTypeData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateTestType({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getGitRepoSettingsQueryKey = (options: Options<GetGitRepoSettingsData>) => createQueryKey('getGitRepoSettings', options);

export const getGitRepoSettingsOptions = (options: Options<GetGitRepoSettingsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGitRepoSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGitRepoSettingsQueryKey(options),
  });
};

export const updateGitRepoSettingsMutation = (options?: Partial<Options<UpdateGitRepoSettingsData>>) => {
  const mutationOptions: MutationOptions<UpdateGitRepoSettingsResponse, UpdateGitRepoSettingsError, Options<UpdateGitRepoSettingsData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateGitRepoSettings({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateWorkflowGroupsMutation = (options?: Partial<Options<UpdateWorkflowGroupsData>>) => {
  const mutationOptions: MutationOptions<unknown, UpdateWorkflowGroupsError, Options<UpdateWorkflowGroupsData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateWorkflowGroups({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateReleaseNameMutation = (options?: Partial<Options<UpdateReleaseNameData>>) => {
  const mutationOptions: MutationOptions<unknown, UpdateReleaseNameError, Options<UpdateReleaseNameData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateReleaseName({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateReleaseNotesMutation = (options?: Partial<Options<UpdateReleaseNotesData>>) => {
  const mutationOptions: MutationOptions<unknown, UpdateReleaseNotesError, Options<UpdateReleaseNotesData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateReleaseNotes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEnvironmentByIdQueryKey = (options: Options<GetEnvironmentByIdData>) => createQueryKey('getEnvironmentById', options);

export const getEnvironmentByIdOptions = (options: Options<GetEnvironmentByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentByIdQueryKey(options),
  });
};

export const updateEnvironmentMutation = (options?: Partial<Options<UpdateEnvironmentData>>) => {
  const mutationOptions: MutationOptions<UpdateEnvironmentResponse, UpdateEnvironmentError, Options<UpdateEnvironmentData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateEnvironment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const unlockEnvironmentMutation = (options?: Partial<Options<UnlockEnvironmentData>>) => {
  const mutationOptions: MutationOptions<UnlockEnvironmentResponse, UnlockEnvironmentError, Options<UnlockEnvironmentData>> = {
    mutationFn: async localOptions => {
      const { data } = await unlockEnvironment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const lockEnvironmentMutation = (options?: Partial<Options<LockEnvironmentData>>) => {
  const mutationOptions: MutationOptions<LockEnvironmentResponse, LockEnvironmentError, Options<LockEnvironmentData>> = {
    mutationFn: async localOptions => {
      const { data } = await lockEnvironment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const extendEnvironmentLockMutation = (options?: Partial<Options<ExtendEnvironmentLockData>>) => {
  const mutationOptions: MutationOptions<ExtendEnvironmentLockResponse, ExtendEnvironmentLockError, Options<ExtendEnvironmentLockData>> = {
    mutationFn: async localOptions => {
      const { data } = await extendEnvironmentLock({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const syncWorkflowsByRepositoryIdQueryKey = (options: Options<SyncWorkflowsByRepositoryIdData>) => createQueryKey('syncWorkflowsByRepositoryId', options);

export const syncWorkflowsByRepositoryIdOptions = (options: Options<SyncWorkflowsByRepositoryIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await syncWorkflowsByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: syncWorkflowsByRepositoryIdQueryKey(options),
  });
};

export const syncWorkflowsByRepositoryIdMutation = (options?: Partial<Options<SyncWorkflowsByRepositoryIdData>>) => {
  const mutationOptions: MutationOptions<unknown, SyncWorkflowsByRepositoryIdError, Options<SyncWorkflowsByRepositoryIdData>> = {
    mutationFn: async localOptions => {
      const { data } = await syncWorkflowsByRepositoryId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUserSettingsQueryKey = (options?: Options<GetUserSettingsData>) => createQueryKey('getUserSettings', options);

export const getUserSettingsOptions = (options?: Options<GetUserSettingsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserSettingsQueryKey(options),
  });
};

export const updateUserSettingsQueryKey = (options: Options<UpdateUserSettingsData>) => createQueryKey('updateUserSettings', options);

export const updateUserSettingsOptions = (options: Options<UpdateUserSettingsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateUserSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: updateUserSettingsQueryKey(options),
  });
};

export const updateUserSettingsMutation = (options?: Partial<Options<UpdateUserSettingsData>>) => {
  const mutationOptions: MutationOptions<unknown, UpdateUserSettingsError, Options<UpdateUserSettingsData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateUserSettings({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getNotificationPreferencesQueryKey = (options?: Options<GetNotificationPreferencesData>) => createQueryKey('getNotificationPreferences', options);

export const getNotificationPreferencesOptions = (options?: Options<GetNotificationPreferencesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNotificationPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getNotificationPreferencesQueryKey(options),
  });
};

export const updateNotificationPreferencesQueryKey = (options: Options<UpdateNotificationPreferencesData>) => createQueryKey('updateNotificationPreferences', options);

export const updateNotificationPreferencesOptions = (options: Options<UpdateNotificationPreferencesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateNotificationPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: updateNotificationPreferencesQueryKey(options),
  });
};

export const updateNotificationPreferencesMutation = (options?: Partial<Options<UpdateNotificationPreferencesData>>) => {
  const mutationOptions: MutationOptions<unknown, UpdateNotificationPreferencesError, Options<UpdateNotificationPreferencesData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateNotificationPreferences({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAllTestTypesQueryKey = (options?: Options<GetAllTestTypesData>) => createQueryKey('getAllTestTypes', options);

export const getAllTestTypesOptions = (options?: Options<GetAllTestTypesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllTestTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllTestTypesQueryKey(options),
  });
};

export const createTestTypeQueryKey = (options: Options<CreateTestTypeData>) => createQueryKey('createTestType', options);

export const createTestTypeOptions = (options: Options<CreateTestTypeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createTestType({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createTestTypeQueryKey(options),
  });
};

export const createTestTypeMutation = (options?: Partial<Options<CreateTestTypeData>>) => {
  const mutationOptions: MutationOptions<CreateTestTypeResponse, CreateTestTypeError, Options<CreateTestTypeData>> = {
    mutationFn: async localOptions => {
      const { data } = await createTestType({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createWorkflowGroupQueryKey = (options: Options<CreateWorkflowGroupData>) => createQueryKey('createWorkflowGroup', options);

export const createWorkflowGroupOptions = (options: Options<CreateWorkflowGroupData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createWorkflowGroup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createWorkflowGroupQueryKey(options),
  });
};

export const createWorkflowGroupMutation = (options?: Partial<Options<CreateWorkflowGroupData>>) => {
  const mutationOptions: MutationOptions<CreateWorkflowGroupResponse, CreateWorkflowGroupError, Options<CreateWorkflowGroupData>> = {
    mutationFn: async localOptions => {
      const { data } = await createWorkflowGroup({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteReleaseCandidateByNameMutation = (options?: Partial<Options<DeleteReleaseCandidateByNameData>>) => {
  const mutationOptions: MutationOptions<DeleteReleaseCandidateByNameResponse, DeleteReleaseCandidateByNameError, Options<DeleteReleaseCandidateByNameData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteReleaseCandidateByName({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAllReleaseInfosQueryKey = (options?: Options<GetAllReleaseInfosData>) => createQueryKey('getAllReleaseInfos', options);

export const getAllReleaseInfosOptions = (options?: Options<GetAllReleaseInfosData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllReleaseInfos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllReleaseInfosQueryKey(options),
  });
};

export const createReleaseCandidateQueryKey = (options: Options<CreateReleaseCandidateData>) => createQueryKey('createReleaseCandidate', options);

export const createReleaseCandidateOptions = (options: Options<CreateReleaseCandidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createReleaseCandidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createReleaseCandidateQueryKey(options),
  });
};

export const createReleaseCandidateMutation = (options?: Partial<Options<CreateReleaseCandidateData>>) => {
  const mutationOptions: MutationOptions<CreateReleaseCandidateResponse, CreateReleaseCandidateError, Options<CreateReleaseCandidateData>> = {
    mutationFn: async localOptions => {
      const { data } = await createReleaseCandidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const publishReleaseDraftQueryKey = (options: Options<PublishReleaseDraftData>) => createQueryKey('publishReleaseDraft', options);

export const publishReleaseDraftOptions = (options: Options<PublishReleaseDraftData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await publishReleaseDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: publishReleaseDraftQueryKey(options),
  });
};

export const publishReleaseDraftMutation = (options?: Partial<Options<PublishReleaseDraftData>>) => {
  const mutationOptions: MutationOptions<unknown, PublishReleaseDraftError, Options<PublishReleaseDraftData>> = {
    mutationFn: async localOptions => {
      const { data } = await publishReleaseDraft({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const generateReleaseNotesQueryKey = (options: Options<GenerateReleaseNotesData>) => createQueryKey('generateReleaseNotes', options);

export const generateReleaseNotesOptions = (options: Options<GenerateReleaseNotesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await generateReleaseNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: generateReleaseNotesQueryKey(options),
  });
};

export const generateReleaseNotesMutation = (options?: Partial<Options<GenerateReleaseNotesData>>) => {
  const mutationOptions: MutationOptions<GenerateReleaseNotesResponse, GenerateReleaseNotesError, Options<GenerateReleaseNotesData>> = {
    mutationFn: async localOptions => {
      const { data } = await generateReleaseNotes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const evaluateQueryKey = (options: Options<EvaluateData>) => createQueryKey('evaluate', options);

export const evaluateOptions = (options: Options<EvaluateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await evaluate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: evaluateQueryKey(options),
  });
};

export const evaluateMutation = (options?: Partial<Options<EvaluateData>>) => {
  const mutationOptions: MutationOptions<unknown, EvaluateError, Options<EvaluateData>> = {
    mutationFn: async localOptions => {
      const { data } = await evaluate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReleaseInfoByNameQueryKey = (options: Options<GetReleaseInfoByNameData>) => createQueryKey('getReleaseInfoByName', options);

export const getReleaseInfoByNameOptions = (options: Options<GetReleaseInfoByNameData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReleaseInfoByName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReleaseInfoByNameQueryKey(options),
  });
};

export const getReleaseInfoByNameMutation = (options?: Partial<Options<GetReleaseInfoByNameData>>) => {
  const mutationOptions: MutationOptions<GetReleaseInfoByNameResponse, GetReleaseInfoByNameError, Options<GetReleaseInfoByNameData>> = {
    mutationFn: async localOptions => {
      const { data } = await getReleaseInfoByName({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setPrPinnedByNumberQueryKey = (options: Options<SetPrPinnedByNumberData>) => createQueryKey('setPrPinnedByNumber', options);

export const setPrPinnedByNumberOptions = (options: Options<SetPrPinnedByNumberData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await setPrPinnedByNumber({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: setPrPinnedByNumberQueryKey(options),
  });
};

export const setPrPinnedByNumberMutation = (options?: Partial<Options<SetPrPinnedByNumberData>>) => {
  const mutationOptions: MutationOptions<unknown, SetPrPinnedByNumberError, Options<SetPrPinnedByNumberData>> = {
    mutationFn: async localOptions => {
      const { data } = await setPrPinnedByNumber({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const syncEnvironmentsQueryKey = (options?: Options<SyncEnvironmentsData>) => createQueryKey('syncEnvironments', options);

export const syncEnvironmentsOptions = (options?: Options<SyncEnvironmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await syncEnvironments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: syncEnvironmentsQueryKey(options),
  });
};

export const syncEnvironmentsMutation = (options?: Partial<Options<SyncEnvironmentsData>>) => {
  const mutationOptions: MutationOptions<SyncEnvironmentsResponse, SyncEnvironmentsError, Options<SyncEnvironmentsData>> = {
    mutationFn: async localOptions => {
      const { data } = await syncEnvironments({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deployToEnvironmentQueryKey = (options: Options<DeployToEnvironmentData>) => createQueryKey('deployToEnvironment', options);

export const deployToEnvironmentOptions = (options: Options<DeployToEnvironmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deployToEnvironment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: deployToEnvironmentQueryKey(options),
  });
};

export const deployToEnvironmentMutation = (options?: Partial<Options<DeployToEnvironmentData>>) => {
  const mutationOptions: MutationOptions<DeployToEnvironmentResponse, DeployToEnvironmentError, Options<DeployToEnvironmentData>> = {
    mutationFn: async localOptions => {
      const { data } = await deployToEnvironment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setBranchPinnedByRepositoryIdAndNameAndUserIdQueryKey = (options: Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>) =>
  createQueryKey('setBranchPinnedByRepositoryIdAndNameAndUserId', options);

export const setBranchPinnedByRepositoryIdAndNameAndUserIdOptions = (options: Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await setBranchPinnedByRepositoryIdAndNameAndUserId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: setBranchPinnedByRepositoryIdAndNameAndUserIdQueryKey(options),
  });
};

export const setBranchPinnedByRepositoryIdAndNameAndUserIdMutation = (options?: Partial<Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>>) => {
  const mutationOptions: MutationOptions<unknown, SetBranchPinnedByRepositoryIdAndNameAndUserIdError, Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>> = {
    mutationFn: async localOptions => {
      const { data } = await setBranchPinnedByRepositoryIdAndNameAndUserId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey('healthCheck', options);

export const healthCheckOptions = (options?: Options<HealthCheckData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthCheckQueryKey(options),
  });
};

export const getAllWorkflowsQueryKey = (options?: Options<GetAllWorkflowsData>) => createQueryKey('getAllWorkflows', options);

export const getAllWorkflowsOptions = (options?: Options<GetAllWorkflowsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllWorkflowsQueryKey(options),
  });
};

export const getWorkflowByIdQueryKey = (options: Options<GetWorkflowByIdData>) => createQueryKey('getWorkflowById', options);

export const getWorkflowByIdOptions = (options: Options<GetWorkflowByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowByIdQueryKey(options),
  });
};

export const getWorkflowsByStateQueryKey = (options: Options<GetWorkflowsByStateData>) => createQueryKey('getWorkflowsByState', options);

export const getWorkflowsByStateOptions = (options: Options<GetWorkflowsByStateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowsByState({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowsByStateQueryKey(options),
  });
};

export const getWorkflowsByRepositoryIdQueryKey = (options: Options<GetWorkflowsByRepositoryIdData>) => createQueryKey('getWorkflowsByRepositoryId', options);

export const getWorkflowsByRepositoryIdOptions = (options: Options<GetWorkflowsByRepositoryIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowsByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowsByRepositoryIdQueryKey(options),
  });
};

export const getLatestWorkflowRunsByPullRequestIdAndHeadCommitQueryKey = (options: Options<GetLatestWorkflowRunsByPullRequestIdAndHeadCommitData>) =>
  createQueryKey('getLatestWorkflowRunsByPullRequestIdAndHeadCommit', options);

export const getLatestWorkflowRunsByPullRequestIdAndHeadCommitOptions = (options: Options<GetLatestWorkflowRunsByPullRequestIdAndHeadCommitData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestWorkflowRunsByPullRequestIdAndHeadCommit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestWorkflowRunsByPullRequestIdAndHeadCommitQueryKey(options),
  });
};

export const getLatestWorkflowRunsByBranchAndHeadCommitQueryKey = (options: Options<GetLatestWorkflowRunsByBranchAndHeadCommitData>) =>
  createQueryKey('getLatestWorkflowRunsByBranchAndHeadCommit', options);

export const getLatestWorkflowRunsByBranchAndHeadCommitOptions = (options: Options<GetLatestWorkflowRunsByBranchAndHeadCommitData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestWorkflowRunsByBranchAndHeadCommit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestWorkflowRunsByBranchAndHeadCommitQueryKey(options),
  });
};

export const getUserPermissionsQueryKey = (options?: Options<GetUserPermissionsData>) => createQueryKey('getUserPermissions', options);

export const getUserPermissionsOptions = (options?: Options<GetUserPermissionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserPermissionsQueryKey(options),
  });
};

export const getLatestTestResultsByPullRequestIdQueryKey = (options: Options<GetLatestTestResultsByPullRequestIdData>) =>
  createQueryKey('getLatestTestResultsByPullRequestId', options);

export const getLatestTestResultsByPullRequestIdOptions = (options: Options<GetLatestTestResultsByPullRequestIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestTestResultsByPullRequestId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestTestResultsByPullRequestIdQueryKey(options),
  });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
  const params = queryKey[0];
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getLatestTestResultsByPullRequestIdInfiniteQueryKey = (
  options: Options<GetLatestTestResultsByPullRequestIdData>
): QueryKey<Options<GetLatestTestResultsByPullRequestIdData>> => createQueryKey('getLatestTestResultsByPullRequestId', options, true);

export const getLatestTestResultsByPullRequestIdInfiniteOptions = (options: Options<GetLatestTestResultsByPullRequestIdData>) => {
  return infiniteQueryOptions<
    GetLatestTestResultsByPullRequestIdResponse,
    GetLatestTestResultsByPullRequestIdError,
    InfiniteData<GetLatestTestResultsByPullRequestIdResponse>,
    QueryKey<Options<GetLatestTestResultsByPullRequestIdData>>,
    number | Pick<QueryKey<Options<GetLatestTestResultsByPullRequestIdData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetLatestTestResultsByPullRequestIdData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLatestTestResultsByPullRequestId({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLatestTestResultsByPullRequestIdInfiniteQueryKey(options),
    }
  );
};

export const getLatestTestResultsByBranchQueryKey = (options: Options<GetLatestTestResultsByBranchData>) => createQueryKey('getLatestTestResultsByBranch', options);

export const getLatestTestResultsByBranchOptions = (options: Options<GetLatestTestResultsByBranchData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestTestResultsByBranch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestTestResultsByBranchQueryKey(options),
  });
};

export const getLatestTestResultsByBranchInfiniteQueryKey = (options: Options<GetLatestTestResultsByBranchData>): QueryKey<Options<GetLatestTestResultsByBranchData>> =>
  createQueryKey('getLatestTestResultsByBranch', options, true);

export const getLatestTestResultsByBranchInfiniteOptions = (options: Options<GetLatestTestResultsByBranchData>) => {
  return infiniteQueryOptions<
    GetLatestTestResultsByBranchResponse,
    GetLatestTestResultsByBranchError,
    InfiniteData<GetLatestTestResultsByBranchResponse>,
    QueryKey<Options<GetLatestTestResultsByBranchData>>,
    number | Pick<QueryKey<Options<GetLatestTestResultsByBranchData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetLatestTestResultsByBranchData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLatestTestResultsByBranch({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLatestTestResultsByBranchInfiniteQueryKey(options),
    }
  );
};

export const getGroupsWithWorkflowsQueryKey = (options: Options<GetGroupsWithWorkflowsData>) => createQueryKey('getGroupsWithWorkflows', options);

export const getGroupsWithWorkflowsOptions = (options: Options<GetGroupsWithWorkflowsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGroupsWithWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGroupsWithWorkflowsQueryKey(options),
  });
};

export const getAllRepositoriesQueryKey = (options?: Options<GetAllRepositoriesData>) => createQueryKey('getAllRepositories', options);

export const getAllRepositoriesOptions = (options?: Options<GetAllRepositoriesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllRepositories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllRepositoriesQueryKey(options),
  });
};

export const getRepositoryByIdQueryKey = (options: Options<GetRepositoryByIdData>) => createQueryKey('getRepositoryById', options);

export const getRepositoryByIdOptions = (options: Options<GetRepositoryByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRepositoryById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRepositoryByIdQueryKey(options),
  });
};

export const getCommitsSinceLastReleaseCandidateQueryKey = (options: Options<GetCommitsSinceLastReleaseCandidateData>) =>
  createQueryKey('getCommitsSinceLastReleaseCandidate', options);

export const getCommitsSinceLastReleaseCandidateOptions = (options: Options<GetCommitsSinceLastReleaseCandidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCommitsSinceLastReleaseCandidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCommitsSinceLastReleaseCandidateQueryKey(options),
  });
};

export const getAllPullRequestsQueryKey = (options?: Options<GetAllPullRequestsData>) => createQueryKey('getAllPullRequests', options);

export const getAllPullRequestsOptions = (options?: Options<GetAllPullRequestsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllPullRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllPullRequestsQueryKey(options),
  });
};

export const getPullRequestByIdQueryKey = (options: Options<GetPullRequestByIdData>) => createQueryKey('getPullRequestById', options);

export const getPullRequestByIdOptions = (options: Options<GetPullRequestByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestByIdQueryKey(options),
  });
};

export const getPullRequestByRepositoryIdAndNumberQueryKey = (options: Options<GetPullRequestByRepositoryIdAndNumberData>) =>
  createQueryKey('getPullRequestByRepositoryIdAndNumber', options);

export const getPullRequestByRepositoryIdAndNumberOptions = (options: Options<GetPullRequestByRepositoryIdAndNumberData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestByRepositoryIdAndNumber({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestByRepositoryIdAndNumberQueryKey(options),
  });
};

export const getPullRequestByRepositoryIdQueryKey = (options: Options<GetPullRequestByRepositoryIdData>) => createQueryKey('getPullRequestByRepositoryId', options);

export const getPullRequestByRepositoryIdOptions = (options: Options<GetPullRequestByRepositoryIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestByRepositoryIdQueryKey(options),
  });
};

export const getAllEnvironmentsQueryKey = (options?: Options<GetAllEnvironmentsData>) => createQueryKey('getAllEnvironments', options);

export const getAllEnvironmentsOptions = (options?: Options<GetAllEnvironmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllEnvironments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllEnvironmentsQueryKey(options),
  });
};

export const getEnvironmentReviewersQueryKey = (options: Options<GetEnvironmentReviewersData>) => createQueryKey('getEnvironmentReviewers', options);

export const getEnvironmentReviewersOptions = (options: Options<GetEnvironmentReviewersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentReviewers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentReviewersQueryKey(options),
  });
};

export const getEnvironmentsByUserLockingQueryKey = (options?: Options<GetEnvironmentsByUserLockingData>) => createQueryKey('getEnvironmentsByUserLocking', options);

export const getEnvironmentsByUserLockingOptions = (options?: Options<GetEnvironmentsByUserLockingData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentsByUserLocking({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentsByUserLockingQueryKey(options),
  });
};

export const getEnvironmentsByRepositoryIdQueryKey = (options: Options<GetEnvironmentsByRepositoryIdData>) => createQueryKey('getEnvironmentsByRepositoryId', options);

export const getEnvironmentsByRepositoryIdOptions = (options: Options<GetEnvironmentsByRepositoryIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentsByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentsByRepositoryIdQueryKey(options),
  });
};

export const getLockHistoryByEnvironmentIdQueryKey = (options: Options<GetLockHistoryByEnvironmentIdData>) => createQueryKey('getLockHistoryByEnvironmentId', options);

export const getLockHistoryByEnvironmentIdOptions = (options: Options<GetLockHistoryByEnvironmentIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLockHistoryByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLockHistoryByEnvironmentIdQueryKey(options),
  });
};

export const getAllEnabledEnvironmentsQueryKey = (options?: Options<GetAllEnabledEnvironmentsData>) => createQueryKey('getAllEnabledEnvironments', options);

export const getAllEnabledEnvironmentsOptions = (options?: Options<GetAllEnabledEnvironmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllEnabledEnvironments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllEnabledEnvironmentsQueryKey(options),
  });
};

export const getAllDeploymentsQueryKey = (options?: Options<GetAllDeploymentsData>) => createQueryKey('getAllDeployments', options);

export const getAllDeploymentsOptions = (options?: Options<GetAllDeploymentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllDeployments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllDeploymentsQueryKey(options),
  });
};

export const getDeploymentByIdQueryKey = (options: Options<GetDeploymentByIdData>) => createQueryKey('getDeploymentById', options);

export const getDeploymentByIdOptions = (options: Options<GetDeploymentByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeploymentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeploymentByIdQueryKey(options),
  });
};

export const getDeploymentsByEnvironmentIdQueryKey = (options: Options<GetDeploymentsByEnvironmentIdData>) => createQueryKey('getDeploymentsByEnvironmentId', options);

export const getDeploymentsByEnvironmentIdOptions = (options: Options<GetDeploymentsByEnvironmentIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeploymentsByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeploymentsByEnvironmentIdQueryKey(options),
  });
};

export const getLatestDeploymentByEnvironmentIdQueryKey = (options: Options<GetLatestDeploymentByEnvironmentIdData>) =>
  createQueryKey('getLatestDeploymentByEnvironmentId', options);

export const getLatestDeploymentByEnvironmentIdOptions = (options: Options<GetLatestDeploymentByEnvironmentIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestDeploymentByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestDeploymentByEnvironmentIdQueryKey(options),
  });
};

export const getActivityHistoryByEnvironmentIdQueryKey = (options: Options<GetActivityHistoryByEnvironmentIdData>) => createQueryKey('getActivityHistoryByEnvironmentId', options);

export const getActivityHistoryByEnvironmentIdOptions = (options: Options<GetActivityHistoryByEnvironmentIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActivityHistoryByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActivityHistoryByEnvironmentIdQueryKey(options),
  });
};

export const getCommitByRepositoryIdAndNameQueryKey = (options: Options<GetCommitByRepositoryIdAndNameData>) => createQueryKey('getCommitByRepositoryIdAndName', options);

export const getCommitByRepositoryIdAndNameOptions = (options: Options<GetCommitByRepositoryIdAndNameData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCommitByRepositoryIdAndName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCommitByRepositoryIdAndNameQueryKey(options),
  });
};

export const getAllBranchesQueryKey = (options?: Options<GetAllBranchesData>) => createQueryKey('getAllBranches', options);

export const getAllBranchesOptions = (options?: Options<GetAllBranchesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllBranches({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllBranchesQueryKey(options),
  });
};

export const getBranchByRepositoryIdAndNameQueryKey = (options: Options<GetBranchByRepositoryIdAndNameData>) => createQueryKey('getBranchByRepositoryIdAndName', options);

export const getBranchByRepositoryIdAndNameOptions = (options: Options<GetBranchByRepositoryIdAndNameData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBranchByRepositoryIdAndName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBranchByRepositoryIdAndNameQueryKey(options),
  });
};

export const deleteWorkflowGroupMutation = (options?: Partial<Options<DeleteWorkflowGroupData>>) => {
  const mutationOptions: MutationOptions<unknown, DeleteWorkflowGroupError, Options<DeleteWorkflowGroupData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteWorkflowGroup({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
